import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Query from 'GraphQL/util/QueryComponent';
import { queryExamQuestions } from 'GraphQL/query/MockExam/MockExamSolutionGroups.query';

import SolutionGroups from './SolutionGroups';

const getTitle = (title, currentSectionIndex, totalQuestions, totalRealQuestions) => {
  const prefix = `Part ${currentSectionIndex}`;
  const suffix =
    totalQuestions !== totalRealQuestions
      ? `${totalQuestions} บทความ ${totalRealQuestions} ข้อ`
      : `${totalRealQuestions} ข้อ`;

  const formattedTitle = `${prefix} ${title} | ${suffix}`;
  return formattedTitle;
};

const getRows = (examId, examCardId, sectionIndex, questions, answers) => {
  const formattedRows = questions.map((question, questionIndex) => {
    const {
      id,
      referenceId,
      displayTopic: topic,
      itemNumber,
      title: questionTitle,
      type: questionType,
    } = question;

    const myAnswer = getAnswer(answers, referenceId);

    return {
      id,
      questionIndex,
      itemNumber,
      topic,
      questionTitle,
      questionType,
      sectionIndex,
      examId,
      examCardId,
      correct: myAnswer ? myAnswer.isCorrect : null,
    };
  });

  return formattedRows;
};

const getAnswer = (answers, referenceId) =>
  answers.find(answer => answer.referenceId === referenceId);

export default class SolutionGroupsContainer extends Component {
  static propTypes = {
    examId: PropTypes.string,
    examCardId: PropTypes.string,
  };

  render() {
    const { examId, examCardId, ...restProps } = this.props;
    return (
      <Query query={queryExamQuestions} variables={{ mockExamId: examId, examCardId }}>
        {data => {
          const { mockExamQuestions, myMockExamAnswers } = data || {};
          const { sections } = mockExamQuestions || {};
          const { answers } = myMockExamAnswers || {};

          const formattedSections = sections.map((section, index) => {
            const {
              title: oriTitle,
              meta: { totalQuestions, totalRealQuestions },
              questions,
            } = section;

            const title = getTitle(oriTitle, index + 1, totalQuestions, totalRealQuestions);
            const rows = getRows(examId, examCardId, index, questions, answers);
            return {
              title,
              rows,
            };
          });

          return <SolutionGroups sections={formattedSections} {...restProps} />;
        }}
      </Query>
    );
  }
}
